import { useCallback } from 'react'
import { useAppContext } from '../contexts/AppContext'
import { useCompareUrlSync } from './useCompareUrlSync'

interface ToggleOptions {
  // Device to return to when leaving compare mode (back to single-device charts)
  sigfoxId?: string
  // Time window (ms) to carry into the /compare view when entering
  timeRange?: { from?: number; to?: number }
}

/**
 * Single source of truth for entering/leaving compare mode.
 *
 * Enter: flips global compareMode on and navigates to /compare (carrying the
 * current time window). Exit: clears the comparison selection and navigates
 * back to /charts. Both the top-toolbar button (mobile) and the sidebar switch
 * (desktop) call this so the behaviour can't drift between them.
 */
export function useCompareToggle() {
  const { compareMode, setCompareMode, clearComparison } = useAppContext()
  const { navigateToCompare, navigateFromCompare } = useCompareUrlSync()

  return useCallback(
    (opts?: ToggleOptions) => {
      if (compareMode) {
        clearComparison()
        navigateFromCompare(opts?.sigfoxId || undefined)
      } else {
        setCompareMode(true)
        navigateToCompare(opts?.timeRange)
      }
    },
    [compareMode, setCompareMode, clearComparison, navigateToCompare, navigateFromCompare]
  )
}
